import { Award, Recycle, Clock, Shield } from "lucide-react"

const About = () => {
  const features = [
    {
      icon: <Award className="h-10 w-10 text-green-600" />,
      title: "Plus de 13 ans d'expérience",
      description:
        "Expérience reconnue dans le domaine de la ferraille et de l'enlèvement d'épaves à Saint-Étienne et dans toute la région Loire et Haute-Loire.",
    },
    {
      icon: <Recycle className="h-10 w-10 text-green-600" />,
      title: "Rachat de métaux au meilleur prix",
      description:
        "Nous rachetons tous types de métaux : cuivre, laiton, aluminium et ferraille au meilleur tarif du marché à Saint-Étienne et environs.",
    },
    {
      icon: <Clock className="h-10 w-10 text-green-600" />,
      title: "Enlèvement d'épave sous 48h",
      description: "Enlèvement gratuit de votre véhicule sous 48h à Saint-Étienne et dans toute la Loire, la Haute-Loire et le Rhône.",
    },
    {
      icon: <Shield className="h-10 w-10 text-green-600" />,
      title: "Service pour particuliers et professionnels",
      description: "Ferrailleur épaviste à votre service, que vous soyez particulier, professionnel ou collectivité dans la région de Saint-Étienne.",
    },
  ]

  return (
    <section id="propos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ferrailleur Épaviste à Saint-Étienne</h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Spécialiste du recyclage et de la récupération de métaux depuis 2010, nous intervenons à Saint-Étienne et dans toute la
            Loire, la Haute-Loire et le Rhône pour tous vos besoins d'enlèvement de véhicules et de rachat de métaux.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-700">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold mb-4">Ferrailleur - Épaviste à Saint-Étienne depuis 2010</h3>
          <p className="text-gray-700 mb-4">
            En tant qu'<strong>épaviste à Saint-Étienne</strong>, Zak se charge gratuitement de l'enlèvement de tout type de véhicule, qu'il soit accidenté, roulant, en panne
            ou brûlé. Un certificat de cession vous sera remis sur place pour faciliter la résiliation de votre
            assurance.
          </p>
          <p className="text-gray-700 mb-4">
            <strong>Ferrailleur professionnel en Loire et Haute-Loire</strong>, nous rachetons également tous types de métaux et ferrailles : cuivre, laiton, aluminium, etc. Les tarifs
            sont calculés selon le prix du marché, mis à jour chaque semaine pour garantir le meilleur prix dans la région.
          </p>
          <p className="text-gray-700 font-semibold">
            Intervention rapide et gratuite à Saint-Étienne et dans toute la Loire, la Haute-Loire, le Rhône et alentours. Pour plus
            d'informations, n'hésitez pas à nous contacter. Vous trouverez notre numéro dans la barre de navigation.
          </p>
        </div>
      </div>
    </section>
  )
}

export default About
